import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import Modal from 'flarum/common/components/Modal';
import withAttr from 'flarum/common/utils/withAttr';
import Select from 'flarum/common/components/Select';

import AgeGroupFilter from '../../common/utils/AgeGroupFilter';

import LoadingIndicator from 'flarum/common/components/LoadingIndicator';

export default class SubmitSuggestionModal extends Modal {
  // True by default, dictates whether the modal can be dismissed by clicking on the background or in the top right corner.
  static isDismissible = true;

  AgeGroupFilter() {
    return {
      default: '',
      ...new AgeGroupFilter().AgeGroupFilter(),
    };
  }

  oninit(vnode) {
    super.oninit(vnode);

    const AgeGroupFilter = this.AgeGroupFilter();
    this.age_group_options = {};
    for (const i in AgeGroupFilter) {
      this.age_group_options[i] = app.translator.trans('td-lesson-plans.lib.agegroup.' + i);
    }

    this.form = {
      title: '',
      materials_required: '',
      procedure: '',
      age_group: '',
      activity_type_id: '',
      developmental_area_id: '',
      learning_outcomes: [],
      children_may_interest: '',
      vocabulary_language: '',
    };

    this.activityTypes = {};
    this.processing = true;
    app.store.find('lesson-plan-activity-types').then((activityTypes) => {
      activityTypes.map((activityType) => {
        this.activityTypes[activityType.id()] = activityType.title();
      });
      m.redraw();
      this.processing = false;
    });

    this.developmentalAreas = {};
    this.processing = true;
    app.store.find('lesson-plan-developmental-areas').then((developmentalAreas) => {
      developmentalAreas.map((developmentalArea) => {
        this.developmentalAreas[developmentalArea.id()] = developmentalArea.title();
      });
      m.redraw();
      this.processing = false;
    });

    this.learningOutcomes = [];
    this.processing = true;
    app.store.find('learning-outcomes').then((learningOutcomes) => {
      this.form.learning_outcomes_ids = [];
      learningOutcomes.map((learningOutcome) => {
        this.learningOutcomes[learningOutcome.id()] = {
          id: learningOutcome.id(),
          title: learningOutcome.title(),
          children: learningOutcome.children(),
        };
        // this.form.learning_outcomes_ids.push(learningOutcome.id());
      });
      m.redraw();
      this.processing = false;
    });
  }

  className() {
    // Custom CSS classes to apply to the modal
    return 'Modal';
  }

  title() {
    // Content to show in the modal's title bar
    return <span>Suggest a Lesson Plan</span>;
  }

  content() {
    // Content to show in the modal's body
    return (
      <form onsubmit={this.onsubmit.bind(this)}>
        <div className="FormFieldWrap mb-2 px-2">
          <div>
            <div className="FormFieldWrap mt-2">
              <strong>
                Title <span className="required">*</span>
              </strong>

              <div className="FormGroup">
                <input
                  className="FormControl"
                  value={this.form.title}
                  oninput={withAttr('value', (value) => {
                    this.form.title = value;
                  })}
                />
              </div>
            </div>

            <div className="FormFieldWrap mt-2">
              <strong>
                Procedure <span className="required">*</span>
              </strong>
              <div className="FormGroup">
                <textarea className="FormControl" value={this.form.procedure} oninput={(e) => (this.form.procedure = e.target.value)} />
              </div>
            </div>

            <div className="FormFieldWrap mt-2">
              <strong>
                Age Group <span className="required">*</span>
              </strong>

              <div className="FormGroup">
                {Select.component({
                  options: this.age_group_options,
                  value: this.form.age_group || 'default',
                  onchange: (value) => {
                    this.form.age_group = value;
                  },
                })}
              </div>
            </div>

            <div className="FormFieldWrap mt-2">
              <strong>Materials Required</strong>
              <div className="FormGroup">
                <textarea
                  className="FormControl"
                  value={this.form.materials_required}
                  oninput={(e) => (this.form.materials_required = e.target.value)}
                />
              </div>
            </div>

            <div className="FormFieldWrap mt-2">
              <strong>Activity Type</strong>

              <div className="FormGroup d-flex flex-row align-items-center">
                <div className="mr-1">
                  {Select.component({
                    options: this.activityTypes,
                    value: this.form.activity_type_id || 'default',
                    onchange: (value) => {
                      this.form.activity_type_id = value;
                    },
                  })}
                </div>
              </div>
            </div>

            <div className="FormFieldWrap mt-2">
              <strong>Developmental Area</strong>
              <div className="FormGroup d-flex flex-row align-items-center">
                <div className="mr-1">
                  {Select.component({
                    options: this.developmentalAreas,
                    value: this.form.developmental_area_id || 'default',
                    onchange: (value) => {
                      this.form.developmental_area_id = value;
                    },
                  })}
                </div>
              </div>
            </div>

            <div className="FormFieldWrap mt-2">
              <strong>Children may be interested in</strong>
              <div className="FormGroup">
                <textarea
                  className="FormControl"
                  value={this.form.children_may_interest}
                  oninput={(e) => (this.form.children_may_interest = e.target.value)}
                />
              </div>
            </div>

            <div className="FormFieldWrap mt-2">
              <strong>Vocabulary/Language/Concept</strong>
              <div>
                <textarea
                  className="FormControl"
                  value={this.form.vocabulary_language}
                  oninput={(e) => (this.form.vocabulary_language = e.target.value)}
                ></textarea>
              </div>
            </div>

            <div className="FormFieldWrap mt-2">
              <strong>Learning outcomes</strong>
              <div className="LearningOutcomesWrap">
                <ul className="LearningOutcomes unlisted px-0 mx-0">
                  {this.learningOutcomes.map((learningOutcome) => {
                    {
                      return (
                        <li className="mb-2">
                          <label>
                            <input
                              type="checkbox"
                              value={learningOutcome.id}
                              data-id={'learning-outcome-' + learningOutcome.id}
                              className="learning-outcome"
                              checked={this.form.learning_outcomes_ids.includes(learningOutcome.id)}
                              oninput={(e) => {
                                if (!e.target.checked) {
                                  let children = document.querySelectorAll('[data-parent="' + learningOutcome.id + '"]');
                                  for (let i in children) {
                                    if (children[i].checked) children[i].checked = false;
                                  }
                                }

                                this.updateLearningOutcomes();
                              }}
                            />
                            <span class="ml-1">{learningOutcome.title}</span>
                          </label>

                          <ul>
                            {learningOutcome.children.map((child) => {
                              return (
                                <li className="mt-1">
                                  <label>
                                    <input
                                      type="checkbox"
                                      value={child.id}
                                      data-parent={child.parent_id}
                                      className="learning-outcome"
                                      checked={this.form.learning_outcomes_ids.includes(child.id)}
                                      oninput={(e) => {
                                        if (e.target.checked) {
                                          let parent_id = e.target.getAttribute('data-parent');
                                          // document.querySelector('[data-id=learning-outcome-' + parent_id + ']').setAttribute('checked', true);
                                          document.querySelector('[data-id=learning-outcome-' + parent_id + ']').checked = true;
                                        }

                                        this.updateLearningOutcomes();
                                      }}
                                    />
                                    <span class="ml-1">{child.title}</span>
                                  </label>
                                </li>
                              );
                            })}
                          </ul>
                        </li>
                      );
                    }
                  })}
                </ul>
              </div>
            </div>

            <div className="FormFieldWrap mt-2">
              <div className="FormGroup">
                {this.processing ? (
                  LoadingIndicator.component()
                ) : (
                  <Button type="submit" className="Button Button--primary" disabled={this.processing}>
                    Submit
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }

  onsubmit(e) {
    app.alerts.clear();
    e.preventDefault();
    this.processing = true;
    var thisClass = this;
    app
      .request({
        method: 'POST',
        url: '/api/lesson-plans/suggest',
        body: { data: this.form },
      })
      .then(function (response) {
        app.alerts.show({ type: 'success' }, 'Thank you!');
        thisClass.processing = false;
        app.modal.close(thisClass);
      })
      .catch(function (e) {
        thisClass.processing = false;
      });
  }

  updateLearningOutcomes() {
    var checkboxes = document.querySelectorAll('input[class=learning-outcome]:checked');
    this.form.learning_outcomes_ids = [];
    for (var i = 0; i < checkboxes.length; i++) {
      this.form.learning_outcomes_ids.push(parseInt(checkboxes[i].value));
    }
  }
}
